import { useEffect, useState } from "react";
import Chart from "./UI/Chart";
import HomeNavbar from "./UI/HomeNavbar";
import './Profile.css';
import { useUserAuth } from "../context/UserAuthContext";
import LoadingModal from './UI/LoadingModal';

const Profile = ({getTotalProgressData}) => {

    const {currentUser} = useUserAuth();
    const [isLoading, setIsLoading] = useState(false);

    const [frontendTotalCompletedSteps, setFrontendTotalCompletedSteps] = useState(0);
    const [backendTotalCompletedSteps, setBackendTotalCompletedSteps] = useState(0);
    const [androidTotalCompletedSteps, setAndroidTotalCompletedSteps] = useState(0);
    const [MLTotalCompletedSteps, setMLTotalCompletedSteps] = useState(0);
    const [gameDevTotalCompletedSteps, setGameDevTotalCompletedSteps] = useState(0);

    useEffect(() => {
        const asyncFunc = async() => {
            setIsLoading(true);
            const totalProgressData = await getTotalProgressData();
            console.log(totalProgressData);
            if (totalProgressData) {
                if(totalProgressData.frontendData){
                    setFrontendTotalCompletedSteps(totalProgressData.frontendData.totalCompletedSteps);
                }
                if(totalProgressData.backendData){
                    setBackendTotalCompletedSteps(totalProgressData.backendData.totalCompletedSteps);
                }
                if(totalProgressData.androidData){
                    setAndroidTotalCompletedSteps(totalProgressData.androidData.totalCompletedSteps);
                }
                if(totalProgressData.MLData){
                    setMLTotalCompletedSteps(totalProgressData.MLData.totalCompletedSteps);
                }
                if(totalProgressData.gameDevData){
                    setGameDevTotalCompletedSteps(totalProgressData.gameDevData.totalCompletedSteps);
                }
                
            }
        };
        asyncFunc();
        setIsLoading(false);
    }, [currentUser]);

    const [firstName, setFirstName] = useState('');

    useEffect(()=>{
        if(currentUser){
            let temp = '';
            for(let char of currentUser.displayName){
                if(char === ' '){
                    break;
                }
                temp += char;
            }
            setFirstName(temp);
        }
    }, [currentUser]);
    

    return (
        <>
            <HomeNavbar />
            <h1 className="profile-main-title">Welcome {firstName} !</h1>
            <h3 className="profile-title">Your Progress Report Stats</h3>
            <div className="main-chart-container">
                <div className='frontend-chart-container'>
                    <Chart title='Frontend Development Progress' completed={parseInt(frontendTotalCompletedSteps)} total={20} color='#c23531'/>
                </div>
                <div className='frontend-chart-container'>
                    <Chart title='Backend Development Progress' completed={backendTotalCompletedSteps} total={15} color='#b430d9'/>
                </div>
                <div className='frontend-chart-container'>
                    <Chart title='Android Development Progress' completed={androidTotalCompletedSteps} total={20} color='#30bad9'/>
                </div>
                <div className='frontend-chart-container'>
                    <Chart title='Machine Learning Progress' completed={MLTotalCompletedSteps} total={20} color='#30d9ba'/>
                </div>
                <div className='frontend-chart-container'>
                    <Chart title='Game Development Progress' completed={gameDevTotalCompletedSteps} total={20} color='#62d930'/>
                </div>
            </div>
            <LoadingModal isLoading={isLoading} msg={'Loading..'}/>
        </>
    )
}

export default Profile;